
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import api from "../../helper/api";

export const forgotPassword = createAsyncThunk("user/forgotPassword", async (payload) => {
  const response = await api.put("admin/change-password", payload);
  console.log(9999, response)
  return response.data;
});

const forgotPasswordSlice = createSlice({
  name: "user",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(forgotPassword.pending, (state) => {
        
        console.log(25, state)
        state.loading = true;
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        console.log(26, action, state)
       
       
        state.loading = false;
        state.data = action.payload.data;
        toast.success(action.payload.message);
      })
      .addCase(forgotPassword.rejected, (state, action) => {
       
        console.log(36,action, state)
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default forgotPasswordSlice.reducer;
